import { render } from "./NodeInfoPanel.vue?vue&type=template&id=1be021f5"
import script from "./NodeInfoPanel.vue?vue&type=script&lang=js"
export * from "./NodeInfoPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__